module.exports = __webpack_public_path__ + "img/out-of-school-children.13ebfe31.png";